module.exports = __webpack_public_path__ + "static/media/employs-marginalized-groups.e01f5d96.png";